import { Box, Typography } from "@mui/material";
import { blueGrey } from "@mui/material/colors";
import React from "react";

interface Props {
  title: string;
  status: 0;
}
export default function EndStep({ title, status }: Props) {
  return (
    <Box
      sx={{
        position: "relative",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          bottom: "-3px",
          right: "14px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography
          sx={{
            fontSize: "10px",
            color: blueGrey[400],
          }}
          noWrap
          color={status === 0 ? "info.main" : ""}
        >
          {title}
        </Typography>
      </Box>
      <Box
        sx={{
          width: "2px",
          backgroundColor: "info.main",
          height: "30px",
        }}
      ></Box>
      <Box
        sx={{
          width: "12px",
          height: "12px",
          borderRadius: "50%",
          backgroundColor: status === 0 ? "info.light" : "success.main",
        }}
      ></Box>
    </Box>
  );
}
